import { useEffect } from 'react';
import { useGetDatabaseScopesService } from '../services/useGetDatabaseScopesService';

const DatabaseScopesFetcher = () => {
    const { getDatabaseScopes } = useGetDatabaseScopesService();

    // Zavisi od izabrane baze, kao i `DatabaseStructureFetcher`. Ranije je stajalo
    // prazno `[]`, pa je promena baze ostavljala brojeve prethodne — što se nije
    // videlo dok su bila samo dva broja na dashboard-u.
    //
    // Sam izbor se više ne navodi: funkcija je `useCallback` nad nalogom i
    // serverom, pa joj se identitet menja tačno kad i izbor.
    useEffect(() => {
        getDatabaseScopes();
    }, [getDatabaseScopes]);

    return null;
};

export default DatabaseScopesFetcher;
